/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/css/index.css";
import React from "react";
import { AppProvider, RootLayout } from "./src/components";

export const wrapRootElement = ({ element }) => (
  <RootLayout>
    <AppProvider>{element}</AppProvider>
  </RootLayout>
);
